import React, { useState } from 'react';
import {
  Button,
  FormControl,
  Grid2,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
} from '@mui/material';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import styles from './styles';
import { makeStyles } from '@mui/styles';
import { useDispatch } from 'react-redux';
import { showRates } from 'js/actions/controlRateActions';
import Swal from 'sweetalert2';
import clsx from 'clsx';
const useStyles = makeStyles(styles);

export default function GetFee() {
  const intl = useIntl();
  const classes = useStyles();
  const dispatch = useDispatch();
  const [values, setValues] = useState({
    division: '',
    rateType: '',
    year: '',
    month: '',
  });
  const { control_rate } = useSelector((state) => state.controlRate);
  const [showTable, setShowTable] = useState(false);

  const tarifas = ['GDBT', 'PDBT', 'GDMTO', 'GDMTH'];

  const divisiones = [
    'Norte',
    'Baja California',
    'Baja California Sur',
    'Bajío',
    'Centro Occidente',
    'Centro Oriente',
    'Centro Sur',
    'Golfo Centro',
    'Golfo Norte',
    'Jalisco',
    'Valle de México Centro',
    'Valle de México Norte',
    'Valle de México Sur',
    'Noroeste',
    'Oriente',
    'Peninsular',
    'Sureste',
  ];

  const years = Array.from(
    { length: 6 },
    (_, i) => new Date().getFullYear() - i
  );

  const meses = [
    intl.formatMessage({ id: 'app.months.jan' }),
    intl.formatMessage({ id: 'app.months.feb' }),
    intl.formatMessage({ id: 'app.months.mar' }),
    intl.formatMessage({ id: 'app.months.apr' }),
    intl.formatMessage({ id: 'app.months.may' }),
    intl.formatMessage({ id: 'app.months.jun' }),
    intl.formatMessage({ id: 'app.months.jul' }),
    intl.formatMessage({ id: 'app.months.ago' }),
    intl.formatMessage({ id: 'app.months.sep' }),
    intl.formatMessage({ id: 'app.months.oct' }),
    intl.formatMessage({ id: 'app.months.nov' }),
    intl.formatMessage({ id: 'app.months.dec' }),
  ];

  const handlerValue = (event, type) => {
    setValues({
      ...values,
      [type]: event.target.value,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (values.division && values.rateType && values.year && values.month) {
      dispatch(showRates(values));
      setShowTable(true);
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Formulario incompleto',
        text: 'Por favor, llena todos los campos antes de continuar.',
      });
    }
  };

  return (
    <div>
      <form className={classes.form} onSubmit={handleSubmit}>
        <Grid2 container={true} spacing={3}>
          <Grid2 size={{ lg: 3, md: 6, xs: 12 }}>
            <FormControl className={classes.textField}>
              <InputLabel id="divisiones-select">
                {intl.formatMessage({ id: 'app.feeCtrl.divisionLbl' })}
              </InputLabel>
              <Select
                id="divisiones-select"
                labelId="divisiones-select"
                onChange={(event) => handlerValue(event, 'division')}
                label={intl.formatMessage({ id: 'app.feeCtrl.divisionLbl' })}
              >
                {divisiones.map((division) => (
                  <MenuItem key={division} value={division}>
                    {division}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid2>
          <Grid2 size={{ lg: 3, md: 6, xs: 12 }}>
            <FormControl className={classes.textField}>
              <InputLabel id="rateType-select">
                {intl.formatMessage({ id: 'app.feeCtrl.feeTypeLbl' })}
              </InputLabel>
              <Select
                id="rateType-select"
                labelId="rateType-select"
                onChange={(event) => handlerValue(event, 'rateType')}
                label={intl.formatMessage({ id: 'app.feeCtrl.feeTypeLbl' })}
              >
                {tarifas.map((tarifa) => (
                  <MenuItem key={tarifa} value={tarifa}>
                    {tarifa}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid2>
          <Grid2 size={{ lg: 3, md: 6, xs: 12 }}>
            <FormControl className={classes.textField}>
              <InputLabel id="year-select">
                {intl.formatMessage({ id: 'app.feeCtrl.yearLbl' })}
              </InputLabel>
              <Select
                id="year-select"
                labelId="year-select"
                onChange={(event) => handlerValue(event, 'year')}
                label={intl.formatMessage({ id: 'app.feeCtrl.yearLbl' })}
              >
                {years.map((year) => (
                  <MenuItem key={year} value={year}>
                    {year}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid2>
          <Grid2 size={{ lg: 3, md: 6, xs: 12 }}>
            <FormControl className={classes.textField}>
              <InputLabel id="month-select">
                {intl.formatMessage({ id: 'app.feeCtrl.monthLbl' })}
              </InputLabel>
              <Select
                id="month-select"
                labelId="month-select"
                onChange={(event) => handlerValue(event, 'month')}
                label={intl.formatMessage({ id: 'app.feeCtrl.monthLbl' })}
              >
                {meses.map((mes, index) => (
                  <MenuItem key={index} value={index + 1}>
                    {mes}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid2>
          <Button
            variant="contained"
            size="large"
            type="submit"
            disabled={
              !values.division ||
              !values.rateType ||
              !values.year ||
              !values.month
            }
            fullWidth={true}
          >
            {intl.formatMessage({ id: 'app.feeCtrl.searchBtn' })}
          </Button>
          <Grid2 size={{ lg: 12, md: 12, xs: 12 }}>
            {showTable && (
              <Grid2>
                <div>
                  <FormControl
                    className={classes.margin}
                    fullWidth={true}
                    variant="outlined"
                  >
                    <InputLabel htmlFor="outlined-adornment-amount">
                      {intl.formatMessage({
                        id: 'app.feeCtrl.distributionLbl',
                      })}
                    </InputLabel>
                    <OutlinedInput
                      disabled={true}
                      id="outlined-adornment-amount"
                      labelWidth={60}
                      startAdornment={
                        <InputAdornment position="start">$</InputAdornment>
                      }
                      value={control_rate.distribucion}
                      label={intl.formatMessage({
                        id: 'app.feeCtrl.distributionLbl',
                      })}
                    />
                  </FormControl>
                  <FormControl
                    className={classes.margin}
                    fullWidth={true}
                    variant="outlined"
                  >
                    <InputLabel htmlFor="outlined-adornment-amount">
                      {intl.formatMessage({ id: 'app.feeCtrl.capacityLbl' })}
                    </InputLabel>
                    <OutlinedInput
                      disabled={true}
                      id="outlined-adornment-amount"
                      labelWidth={60}
                      startAdornment={
                        <InputAdornment position="start">$</InputAdornment>
                      }
                      value={control_rate.capacidad}
                      label={intl.formatMessage({
                        id: 'app.feeCtrl.capacityLbl',
                      })}
                    />
                  </FormControl>
                  {control_rate.cenace ? (
                    <TextField
                      className={clsx(classes.margin, classes.textField)}
                      disabled={true}
                      id="outlined-start-adornment"
                      slotProps={{
                        input: {
                          startAdornment: (
                            <InputAdornment position="start">B</InputAdornment>
                          ),
                        },
                      }}
                      label="CENACE"
                      value={
                        control_rate.cenace &&
                        Array.isArray(control_rate.cenace)
                          ? control_rate.cenace[0]
                          : control_rate.cenace
                            ? control_rate.cenace
                            : 0
                      }
                      variant="outlined"
                    />
                  ) : (
                    <TextField
                      className={clsx(classes.margin, classes.textField)}
                      disabled={true}
                      id="outlined-start-adornment"
                      slotProps={{
                        input: {
                          startAdornment: (
                            <InputAdornment position="start">B</InputAdornment>
                          ),
                        },
                      }}
                      label="CENACE"
                      value={
                        control_rate.cenace &&
                        Array.isArray(control_rate.cenace)
                          ? control_rate.cenace[0]
                          : control_rate.cenace
                            ? control_rate.cenace
                            : 0
                      }
                      variant="outlined"
                    />
                  )}
                  {control_rate.transmision ? (
                    <TextField
                      className={clsx(classes.margin, classes.textField)}
                      disabled={true}
                      id="outlined-start-adornment"
                      slotProps={{
                        input: {
                          startAdornment: (
                            <InputAdornment position="start">I</InputAdornment>
                          ),
                        },
                      }}
                      value={
                        control_rate.cenace &&
                        Array.isArray(control_rate.cenace)
                          ? control_rate.cenace[1]
                          : 0
                      }
                      variant="outlined"
                    />
                  ) : (
                    ' '
                  )}
                  {control_rate.transmision ? (
                    <TextField
                      className={clsx(classes.margin, classes.textField)}
                      disabled={true}
                      id="outlined-start-adornment"
                      slotProps={{
                        input: {
                          startAdornment: (
                            <InputAdornment position="start">P</InputAdornment>
                          ),
                        },
                      }}
                      value={
                        control_rate.cenace &&
                        Array.isArray(control_rate.cenace)
                          ? control_rate.cenace[2]
                          : 0
                      }
                      variant="outlined"
                    />
                  ) : (
                    ' '
                  )}
                </div>
                <div>
                  {control_rate.transmision ? (
                    <TextField
                      className={clsx(classes.margin, classes.textField)}
                      disabled={true}
                      id="outlined-start-adornment"
                      slotProps={{
                        input: {
                          startAdornment: (
                            <InputAdornment position="start">B</InputAdornment>
                          ),
                        },
                      }}
                      label={intl.formatMessage({
                        id: 'app.feeCtrl.transmisionLbl',
                      })}
                      value={
                        control_rate.transmision &&
                        Array.isArray(control_rate.transmision)
                          ? control_rate.transmision[0]
                          : control_rate.transmision
                            ? control_rate.transmision
                            : 0
                      }
                      variant="outlined"
                    />
                  ) : (
                    ' '
                  )}
                  {control_rate.transmision ? (
                    <TextField
                      className={clsx(classes.margin, classes.textField)}
                      disabled={true}
                      id="outlined-start-adornment"
                      slotProps={{
                        input: {
                          startAdornment: (
                            <InputAdornment position="start">I</InputAdornment>
                          ),
                        },
                      }}
                      value={
                        control_rate.transmision &&
                        Array.isArray(control_rate.transmision)
                          ? control_rate.transmision[1]
                          : 0
                      }
                      variant="outlined"
                    />
                  ) : (
                    ' '
                  )}
                  {control_rate.transmision ? (
                    <TextField
                      className={clsx(classes.margin, classes.textField)}
                      disabled={true}
                      id="outlined-start-adornment"
                      slotProps={{
                        input: {
                          startAdornment: (
                            <InputAdornment position="start">P</InputAdornment>
                          ),
                        },
                      }}
                      value={
                        control_rate.transmision &&
                        Array.isArray(control_rate.transmision)
                          ? control_rate.transmision[2]
                          : 0
                      }
                      variant="outlined"
                    />
                  ) : (
                    ' '
                  )}
                </div>
                <div>
                  {control_rate.scnmem ? (
                    <TextField
                      className={clsx(classes.margin, classes.textField)}
                      disabled={true}
                      id="outlined-start-adornment"
                      slotProps={{
                        input: {
                          startAdornment: (
                            <InputAdornment position="start">B</InputAdornment>
                          ),
                        },
                      }}
                      label="SCnMEM"
                      value={
                        control_rate.scnmem &&
                        Array.isArray(control_rate.scnmem)
                          ? control_rate.scnmem[0]
                          : control_rate.scnmem
                            ? control_rate.scnmem
                            : 0
                      }
                      variant="outlined"
                    />
                  ) : (
                    ' '
                  )}
                  {control_rate.scnmem ? (
                    <TextField
                      className={clsx(classes.margin, classes.textField)}
                      disabled={true}
                      id="outlined-start-adornment"
                      slotProps={{
                        input: {
                          startAdornment: (
                            <InputAdornment position="start">I</InputAdornment>
                          ),
                        },
                      }}
                      value={
                        control_rate.scnmem &&
                        Array.isArray(control_rate.scnmem)
                          ? control_rate.scnmem[1]
                          : 0
                      }
                      variant="outlined"
                    />
                  ) : (
                    ' '
                  )}
                  {control_rate.transmision ? (
                    <TextField
                      className={clsx(classes.margin, classes.textField)}
                      disabled={true}
                      id="outlined-start-adornment"
                      slotProps={{
                        input: {
                          startAdornment: (
                            <InputAdornment position="start">P</InputAdornment>
                          ),
                        },
                      }}
                      value={
                        control_rate.scnmem &&
                        Array.isArray(control_rate.scnmem)
                          ? control_rate.scnmem[2]
                          : 0
                      }
                      variant="outlined"
                    />
                  ) : (
                    ' '
                  )}
                </div>
                <div>
                  {control_rate.generacion ? (
                    <TextField
                      className={clsx(classes.margin, classes.textField)}
                      disabled={true}
                      id="outlined-start-adornment"
                      slotProps={{
                        input: {
                          startAdornment: (
                            <InputAdornment position="start">B</InputAdornment>
                          ),
                        },
                      }}
                      label={intl.formatMessage({
                        id: 'app.feeCtrl.generationLbl',
                      })}
                      value={
                        control_rate.generacion &&
                        Array.isArray(control_rate.generacion)
                          ? control_rate.generacion[0]
                          : control_rate.generacion
                            ? control_rate.generacion
                            : 0
                      }
                      variant="outlined"
                    />
                  ) : (
                    ' '
                  )}
                  {control_rate.scnmem ? (
                    <TextField
                      className={clsx(classes.margin, classes.textField)}
                      disabled={true}
                      id="outlined-start-adornment"
                      slotProps={{
                        input: {
                          startAdornment: (
                            <InputAdornment position="start">I</InputAdornment>
                          ),
                        },
                      }}
                      value={
                        control_rate.generacion &&
                        Array.isArray(control_rate.generacion)
                          ? control_rate.generacion[1]
                          : 0
                      }
                      variant="outlined"
                    />
                  ) : (
                    ' '
                  )}
                  {control_rate.transmision ? (
                    <TextField
                      className={clsx(classes.margin, classes.textField)}
                      disabled={true}
                      id="outlined-start-adornment"
                      slotProps={{
                        input: {
                          startAdornment: (
                            <InputAdornment position="start">P</InputAdornment>
                          ),
                        },
                      }}
                      value={
                        control_rate.generacion &&
                        Array.isArray(control_rate.generacion)
                          ? control_rate.generacion[2]
                          : 0
                      }
                      variant="outlined"
                    />
                  ) : (
                    ' '
                  )}
                </div>
                <div>
                  {control_rate.total ? (
                    <TextField
                      className={clsx(classes.margin, classes.textField)}
                      disabled={true}
                      id="outlined-start-adornment"
                      slotProps={{
                        input: {
                          startAdornment: (
                            <InputAdornment position="start">B</InputAdornment>
                          ),
                        },
                      }}
                      label={intl.formatMessage({ id: 'app.feeCtrl.total' })}
                      value={
                        control_rate.total && control_rate.total.B
                          ? control_rate.total.B
                          : control_rate.total && control_rate.total.variable
                            ? control_rate.total.variable
                            : 0
                      }
                      variant="outlined"
                    />
                  ) : (
                    ' '
                  )}
                  {control_rate.total ? (
                    <TextField
                      className={clsx(classes.margin, classes.textField)}
                      disabled={true}
                      id="outlined-start-adornment"
                      slotProps={{
                        input: {
                          startAdornment: (
                            <InputAdornment position="start">I</InputAdornment>
                          ),
                        },
                      }}
                      value={
                        control_rate.total && control_rate.total.I
                          ? control_rate.total.I
                          : 0
                      }
                      variant="outlined"
                    />
                  ) : (
                    ' '
                  )}
                  {control_rate.total ? (
                    <TextField
                      className={clsx(classes.margin, classes.textField)}
                      disabled={true}
                      id="outlined-start-adornment"
                      slotProps={{
                        input: {
                          startAdornment: (
                            <InputAdornment position="start">P</InputAdornment>
                          ),
                        },
                      }}
                      value={
                        control_rate.total && control_rate.total.P
                          ? control_rate.total.P
                          : 0
                      }
                      variant="outlined"
                    />
                  ) : (
                    ' '
                  )}
                  {control_rate.total ? (
                    <TextField
                      className={clsx(classes.margin, classes.textField)}
                      disabled={true}
                      id="outlined-start-adornment"
                      slotProps={{
                        input: {
                          startAdornment: (
                            <InputAdornment position="start">
                              DYC
                            </InputAdornment>
                          ),
                        },
                      }}
                      value={control_rate.total ? control_rate.total.dyc : 0}
                      variant="outlined"
                    />
                  ) : (
                    ' '
                  )}
                </div>
              </Grid2>
            )}
          </Grid2>
        </Grid2>
      </form>
    </div>
  );
}
